var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12L17 8V11L8 11V13L17 13V16L22 12Z",
    fill: "#95A4AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.999 21.001C13.404 21.001 15.664 20.064 17.363 18.364L15.949 16.95C14.627 18.272 12.869 19.001 10.999 19.001C9.12904 19.001 7.37104 18.272 6.04904 16.95C4.72704 15.628 3.99804 13.87 3.99804 12C3.99804 10.13 4.72704 8.37198 6.04904 7.04998C7.37104 5.72798 9.12904 4.99898 10.999 4.99898C12.869 4.99898 14.627 5.72798 15.949 7.04998L17.363 5.63598C15.664 3.93598 13.404 2.99898 10.999 2.99898C8.59404 2.99898 6.33404 3.93598 4.63504 5.63598C2.93504 7.33498 1.99804 9.59498 1.99804 12C1.99804 14.405 2.93504 16.665 4.63504 18.364C6.33404 20.064 8.59404 21.001 10.999 21.001Z",
    fill: "#95A4AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientLogoutIcon);
export default __webpack_public_path__ + "static/media/client_logout_icon.7be525bdc00e628e9b6deb10dee64fbb.svg";
export { ForwardRef as ReactComponent };